/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import promiseRetry from "promise-retry";
import { forceRefreshAccessToken } from "@mgdx-libs/firebase";
import * as runtime from "../runtime";
import {
  PharmacyCounselorVideoChat,
  PharmacyCounselorVideoChatFromJSON,
  PharmacyCounselorVideoChatToJSON,
} from "../models";

export interface PatchCounselingsVideoChatRequest {
  counselingId: number;
  pharmacyCounselorVideoChat: PharmacyCounselorVideoChat;
}

/**
 *
 */
export class VideoChatApi extends runtime.BaseAPI {
  /**
   * Change video-chat address information
   */
  async patchCounselingsVideoChatRaw(
    requestParameters: PatchCounselingsVideoChatRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PharmacyCounselorVideoChat>> {
    if (requestParameters.counselingId === null || requestParameters.counselingId === undefined) {
      throw new runtime.RequiredError(
        "counselingId",
        "Required parameter requestParameters.counselingId was null or undefined when calling patchCounselingsVideoChat."
      );
    }

    if (
      requestParameters.pharmacyCounselorVideoChat === null ||
      requestParameters.pharmacyCounselorVideoChat === undefined
    ) {
      throw new runtime.RequiredError(
        "pharmacyCounselorVideoChat",
        "Required parameter requestParameters.pharmacyCounselorVideoChat was null or undefined when calling patchCounselingsVideoChat."
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/counselings/{counseling_id}/video-chat`.replace(
          `{${"counseling_id"}}`,
          encodeURIComponent(String(requestParameters.counselingId))
        ),
        method: "PATCH",
        headers: headerParameters,
        query: queryParameters,
        body: PharmacyCounselorVideoChatToJSON(requestParameters.pharmacyCounselorVideoChat),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PharmacyCounselorVideoChatFromJSON(jsonValue));
  }

  /**
   * Change video-chat address information
   */
  async patchCounselingsVideoChat(
    requestParameters: PatchCounselingsVideoChatRequest,
    initOverrides?: RequestInit
  ): Promise<PharmacyCounselorVideoChat> {
    return promiseRetry(
      (retry) =>
        this.patchCounselingsVideoChatRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }
}
